<template>
  <MyManage>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">

      <el-tab-pane label="手动分润信息" name="handProfitList" v-if="checkPermission(['bee:res:handProfit:getHandProfits'])">
        <handProfitPage v-if="activeName=='handProfitList'"></handProfitPage>
      </el-tab-pane>
    </el-tabs>
  </MyManage>
</template>

<script>
  import handProfitPage from '@/module/resourceCenter/page/handProfit/list.vue'
  import MyManage from '@/components/MyManage'

  export default {
    components: {
      MyManage,
      handProfitPage,
    },
    data() {
      return {
        activeName: 'handProfitList'
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick(tab, event) {
        // console.log(this.activeName)
      }
    }
  }
</script>

<style>
  .el-dialog__header {
    text-align: center;
  }

  #manage .el-switch.is-disabled .el-switch__core, #manage .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/handProfit/manage.vue